import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Collapsible } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';
import CollapsibleIcon from '@spotahome/ui-library/src/tenant/components/icons/CollapsibleIcon';

import HiwStepTitle from './HiwStepTitle';
import HiwStepContent from './HiwStepContent';

import './HiwStepItemCollapsible.scss';

const noop = () => {};

const HiwStepItemCollapsible = ({
  stepNumber,
  titleKey,
  descriptionKey,
  bulletPoints = [],
  cta = null,
  isCollapsed = true,
  onCollapsedChange = noop
}) => {
  return (
    <Collapsible
      className={classNames('hiw-step-item-collapsible', {
        'hiw-step-item-collapsible--uncollapsed': !isCollapsed
      })}
      hasIcon
      onCollapsedChange={onCollapsedChange}
      isCollapsed={isCollapsed}
      iconClosed={<CollapsibleIcon collapsed />}
      iconOpened={<CollapsibleIcon collapsed={false} />}
      renderHeader={() => (
        <HiwStepTitle stepNumber={stepNumber} title={trans(titleKey)} />
      )}
      renderBody={() => (
        <HiwStepContent
          description={trans(descriptionKey)}
          bulletPoints={bulletPoints}
          cta={cta}
        />
      )}
    />
  );
};

HiwStepItemCollapsible.propTypes = {
  stepNumber: PropTypes.number.isRequired,
  titleKey: PropTypes.string.isRequired,
  descriptionKey: PropTypes.string.isRequired,
  bulletPoints: PropTypes.arrayOf(
    PropTypes.shape({
      titleKey: PropTypes.string.isRequired,
      textKey: PropTypes.string.isRequired
    })
  ),
  cta: PropTypes.shape({
    textKey: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired
  }),
  isCollapsed: PropTypes.bool,
  onCollapsedChange: PropTypes.func
};

export default HiwStepItemCollapsible;
